import { Component, h, Host, Prop } from '@stencil/core'
import { TermsFooter } from 'src/ui/components'
import { classes } from 'src/utils/css'

import { AppSharedPropsStore } from '../../app'
import { GoogleAuthButton, MicrosoftAuthButton, SSOAuthButton } from '../../sign_in/ui'
import { openUrlInNewWindow } from '../../utils/url'

@Component({
  tag: 'page-signin',
})
export class Signin {
  @Prop() signinUrl: string
  @Prop() googleUrl: string
  @Prop() microsoftUrl: string
  @Prop() ssoSignInUrl: string
  @Prop() fromGoogle = false
  @Prop() fromMicrosoft = false
  @Prop() showMissingScopesError = false

  componentDidRender() {
    if (window.electronAPI?.resizeWindow) {
      window.electronAPI.resizeWindow(420, 200)
    }
  }

  renderBrowser() {
    return (
      <div class='mt-2 spacing-y-3' style={{ width: '300px' }}>
        <GoogleAuthButton
          authUrl={this.googleUrl}
          label='Sign in with Google'
          fromGoogle={this.fromGoogle}
          showMissingScopesError={this.showMissingScopesError}
        />
        <MicrosoftAuthButton
          authUrl={this.microsoftUrl}
          label='Sign in with Microsoft'
          fromMicrosoft={this.fromMicrosoft}
          showMissingScopesError={this.showMissingScopesError}
        />
        <SSOAuthButton url={this.ssoSignInUrl} label='Sign in with SSO' />
      </div>
    )
  }

  renderElectron() {
    return (
      <div class='flex flex-col self-center rounded-sm -py-12 bg-fill-2'>
        <a
          href='fathom://oauth2/login'
          class='flex relative flex-shrink-0 justify-center items-center p-2 w-full text-lg font-semibold tracking-wide leading-none text-link hover:text-surface-lower truncate hover:bg-link rounded-md border border-link focus:shadow-outline transition duration-200 flex-grow-1'
        >
          Sign in
          <ui-icon icon='chevron-right' size='xl' class='pl-8' />
        </a>
      </div>
    )
  }

  renderZapp() {
    return (
      <button
        color='link'
        class='flex relative flex-shrink-0 justify-center items-center p-3 w-full text-xl font-semibold tracking-wide leading-none text-link hover:text-surface-lower truncate hover:bg-link rounded-md border border-link focus:shadow-outline transition duration-200 flex-grow-1'
        style={{ outline: 'none' }}
        onClick={async () => await openUrlInNewWindow(this.signinUrl)}
      >
        <ui-icon icon='camera-video' size='4xl' class='pr-3' />
        Sign in with Zoom
        <ui-icon icon='chevron-right' size='xl' class='pl-16' />
      </button>
    )
  }

  renderForm() {
    if (AppSharedPropsStore.state.inZapp) {
      return this.renderZapp()
    } else if (AppSharedPropsStore.state.inElectron) {
      return this.renderElectron()
    } else {
      return this.renderBrowser()
    }
  }

  render() {
    return (
      <Host
        class={`flex flex-col justify-center items-center h-full ${classes(
          !AppSharedPropsStore.state.inElectron,
          'spacing-y-6',
          'spacing-y-4'
        )}`}
      >
        <ui-logo class={classes(!AppSharedPropsStore.state.inElectron, 'text-3xl', 'text-lg')} />
        {this.renderForm()}

        <TermsFooter class={classes(!AppSharedPropsStore.state.inElectron, 'text-base', 'text-sm leading-18px')} />
      </Host>
    )
  }
}
